/**
 * Centralized formatting helpers so every number & label reads the same
 * across the app. NEVER call `toLocaleString` inline anymore — use these.
 */

/** $6,888.00 · handles null/undefined/NaN gracefully. */
export function formatMoney(value, { decimals = 2, compact = false } = {}) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "$0.00";
  if (compact && Math.abs(n) >= 1_000_000) {
    return n.toLocaleString(undefined, {
      style: "currency",
      currency: "USD",
      notation: "compact",
      maximumFractionDigits: 1,
    });
  }
  return n.toLocaleString(undefined, {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** Plain integer with thousand separators. */
export function formatNumber(value, decimals = 0) {
  const n = Number(value);
  if (!Number.isFinite(n)) return "0";
  return n.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

/** "3 min ago" / "2h ago" / "4d ago" — for lists. */
export function formatRelative(iso) {
  if (!iso) return "";
  const t = typeof iso === "string" ? Date.parse(iso) : Number(iso);
  if (!Number.isFinite(t)) return "";
  const diffSec = Math.floor((Date.now() - t) / 1000);
  if (diffSec < 45) return "just now";
  if (diffSec < 3600) return `${Math.floor(diffSec / 60)}m ago`;
  if (diffSec < 86400) return `${Math.floor(diffSec / 3600)}h ago`;
  if (diffSec < 2592000) return `${Math.floor(diffSec / 86400)}d ago`;
  const d = new Date(t);
  return d.toLocaleDateString();
}

/** ISO → 'Mar 18, 2026' */
export function formatDate(iso) {
  if (!iso) return "—";
  const t = typeof iso === "string" ? new Date(iso) : iso;
  if (Number.isNaN(t.getTime())) return "—";
  return t.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
}
